import { FormTitle } from "@/components/Forms/components/MonolithFormComponents";
import { Button, ButtonColor, Tooltip } from "@monolith-forensics/monolith-ui";
import { InfoIcon } from "lucide-react";
import { FC } from "react";
import styled, { useTheme } from "styled-components";

export const InteractiveInfoIcon = styled(InfoIcon)`
  transition: color 0.2s, stroke 0.2s; // Add stroke transition
  margin-top: 5px;
  margin-left: 5px;
  stroke: ${(
    { theme } // manipulate SVG directly with stroke
  ) => theme.palette.tooltips.primary};

  cursor: pointer;

  &:hover {
    stroke: ${({ theme }) =>
      theme.palette.tooltips.secondary}; // Change stroke on hover
  }
`;

interface UserActionBlockProps {
  title: string;
  tooltip?: string;
  buttonProps?: {
    size?: string;
    color?: string;
    variant?: string;
    primaryText?: string;
    secondaryText?: string;
    action?: () => void;
  };
}

const UserActionBlock: FC<UserActionBlockProps> = ({
  title,
  buttonProps,
  tooltip,
}) => {
  const theme: any = useTheme();
  return (
    <>
      <div
        style={{
          margin: "35px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "2px",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "2px",
            }}
          >
            <FormTitle>{title}</FormTitle>
            <Tooltip content={tooltip} delayDuration={1}>
              <InteractiveInfoIcon
                size={18}
                strokeWidth={2}
                color={theme.palette.text.primary}
              />
            </Tooltip>
          </div>
          <Button
            size="xs"
            color={(buttonProps?.color as ButtonColor) || "primary"}
            variant="light"
            onClick={buttonProps?.action}
          >
            {buttonProps?.primaryText || "Submit"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default UserActionBlock;
